import { Phone } from "lucide-react";
import { BRAND } from "@/lib/site";
import { TESTIDS } from "@/constants/testIds/site";

export const FloatingContact = () => (
  <a
    href={`tel:${BRAND.phoneRaw}`}
    data-testid={TESTIDS.floatingCallLink}
    className="md:hidden fixed bottom-5 inset-x-5 z-30 bg-[var(--primary)] text-white text-[13px] font-semibold tracking-[0.12em] uppercase rounded-sm py-4 flex items-center justify-center gap-2 shadow-[0_10px_30px_rgba(30,63,51,0.3)]"
  >
    <Phone size={15} strokeWidth={1.7} />
    Call leasing · {BRAND.phone}
  </a>
);

export default FloatingContact;
